import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import * as AppActions from '@app/store/actions/app.actions';
import { selectAppState } from '@app/store/selectors/app.selectors';
import { SeoService } from '@app/modules/core/services/seo.service';
import { CoreService } from '@app/modules/core/services/core.service';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { FAQCategories } from '@app/modules/core/services/faqs.service';
import { FunctionsService } from '@app/modules/core/services/functions.service';
import { CoreProductUseCases } from '@app/store/enums/core-product-use-cases.enum';
import { AlaCarteProductInterface, AlaCarteQrTypes, QrGeneratorNavigatorCategories, enumValuesToArray } from 'shared-library';

@Component({
    selector: 'app-core-product-use-cases',
    templateUrl: './core-product-use-cases.component.html',
    styleUrls: ['./core-product-use-cases.component.scss']
})
export class CoreProductUseCasesComponent implements OnInit, OnDestroy {

    private subscriptions: Subscription[] = []
    appState$ = this.store.select(selectAppState);

    session_info: SessionInfo
    qr_category: QrGeneratorNavigatorCategories
    qr_category_use_case: CoreProductUseCases
    products: AlaCarteProductInterface[]

    is_alacarte = false
    faq_category = FAQCategories.ALACARTE_MEMORIES
    qr_categories = {
        PDF: QrGeneratorNavigatorCategories.PDF,
        IMAGES: QrGeneratorNavigatorCategories.IMAGES,
        MEMORIES: QrGeneratorNavigatorCategories.MEMORIES,
        VCARD_PRO: QrGeneratorNavigatorCategories.VCARD_PRO,
        RESTAURANT_MENU: QrGeneratorNavigatorCategories.RESTAURANT_MENU,
    }

    qr_category_use_cases = {
        MEMORIES_PROMS: CoreProductUseCases.MEMORIES_PROMS,
        MEMORIES_CHARITY: CoreProductUseCases.MEMORIES_CHARITY,
        MEMORIES_WEDDING: CoreProductUseCases.MEMORIES_WEDDING,
        MEMORIES_CONCERT: CoreProductUseCases.MEMORIES_CONCERT,
        MEMORIES_HOLIDAY: CoreProductUseCases.MEMORIES_HOLIDAY,
        MEMORIES_BIRTHDAY: CoreProductUseCases.MEMORIES_BIRTHDAY,
        MEMORIES_CORPORATE: CoreProductUseCases.MEMORIES_CORPORATE,
        MEMORIES_CHRISTMAS: CoreProductUseCases.MEMORIES_CHRISTMAS,
        MEMORIES_BABY_SHOWER: CoreProductUseCases.MEMORIES_BABY_SHOWER,
        MEMORIES_BACHELORETTE: CoreProductUseCases.MEMORIES_BACHELORETTE,
        MEMORIES_FAMILY_REUNIONS: CoreProductUseCases.MEMORIES_FAMILY_REUNIONS,
        MEMORIES_SPORT_CEREMONIES: CoreProductUseCases.MEMORIES_SPORT_CEREMONIES,

        PDF_MENU: CoreProductUseCases.PDF_MENU,
        PDF_REAL_ESTATE: CoreProductUseCases.PDF_REAL_ESTATE,
        PDF_SPAS_SALONS: CoreProductUseCases.PDF_SPAS_SALONS,

        IMAGES_MENU: CoreProductUseCases.IMAGES_MENU,
        IMAGES_REAL_ESTATE: CoreProductUseCases.IMAGES_REAL_ESTATE,
        IMAGES_SPAS_SALONS: CoreProductUseCases.IMAGES_SPAS_SALONS,

        RESTAURANT_MENU: CoreProductUseCases.RESTAURANT_MENU,
        RESTAURANT_MENU_CAFES: CoreProductUseCases.RESTAURANT_MENU_CAFES,
        RESTAURANT_MENU_CATERING: CoreProductUseCases.RESTAURANT_MENU_CATERING,
        RESTAURANT_MENU_FOOD_TRUCKS: CoreProductUseCases.RESTAURANT_MENU_FOOD_TRUCKS,
        RESTAURANT_MENU_HOSPITALITY: CoreProductUseCases.RESTAURANT_MENU_HOSPITALITY,
        RESTAURANT_MENU_RETAIL_STORES: CoreProductUseCases.RESTAURANT_MENU_RETAIL_STORES,

        VCARD_PRO_COMPANY_PROFILE: CoreProductUseCases.VCARD_PRO_COMPANY_PROFILE,

    }

    constructor(
        private store: Store,
        private router: Router,
        private seo: SeoService,
        private coreService: CoreService,
        private activatedRoute: ActivatedRoute,
        public functionService: FunctionsService
    ) {
        this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => this.session_info = si))
    }

    ngOnInit(): void {
        this.subscriptions.push(this.activatedRoute.params.subscribe(params => {
            this.qr_category = params['qr_category']
            this.qr_category_use_case = params['use_case']
            if (![
                QrGeneratorNavigatorCategories.PDF,
                QrGeneratorNavigatorCategories.IMAGES,
                QrGeneratorNavigatorCategories.MEMORIES,
                QrGeneratorNavigatorCategories.VCARD_PRO,
                QrGeneratorNavigatorCategories.RESTAURANT_MENU
            ].includes(this.qr_category) || !enumValuesToArray(CoreProductUseCases).includes(this.qr_category_use_case)) this.router.navigateByUrl("/404")
            this.seo.generateMetaTags(this.qr_category_use_case)
            this.is_alacarte = [QrGeneratorNavigatorCategories.MEMORIES].includes(this.qr_category)
            if (this.is_alacarte) {
                this.store.dispatch(AppActions.fetchAlaCartePrices({ qr_category: this.qr_category as AlaCarteQrTypes }))
                this.subscriptions.push(this.appState$.subscribe(ls => this.products = ls.data.cache.products.alacarte.memories))
            } else {
                this.products = []
            }
        }));
        this.functionService.initializeTooltip()
    }

    ngOnDestroy(): void {
        this.subscriptions.map(subscription => subscription.unsubscribe())
    }

    getHomeAddress(): string {

        if (this.qr_categories.MEMORIES === this.qr_category) {
            return "/branded-qr-code-for-memories"
        }

        if (this.qr_categories.RESTAURANT_MENU === this.qr_category) {
            return "/branded-qr-code-for-restaurant-menu"
        }

        if (this.qr_categories.PDF === this.qr_category) {
            return "/branded-qr-code-for-pdf"
        }

        if (this.qr_categories.IMAGES === this.qr_category) {
            return "/branded-qr-code-for-images"
        }

        if (this.qr_categories.VCARD_PRO === this.qr_category) {
            return "/branded-qr-code-for-vcard-pro"
        }

        return this.session_info?.last_routes.new_home || "/"
    }

}
